<!-- 港澳高校 -->
<template>
  <div>
    <el-image class="policyType5-banner" :src="require('@/assets/images/policy/policyType7-banner.png')"></el-image>
    <div class="policyType5-process">
      <div style="text-align: center;">
        <el-image class="policyType5-titleImage" :src="require('@/assets/images/policy/policyType7-title.png')"></el-image>
      </div>
      <div class="school">
        <div v-for="item in schoolList" class="school-item">
          <img class="school-image" :src="item.iconUrl">
          <div style="flex-shrink: 0;">
            <div class="school-name">{{ item.name }}</div>
            <a v-if="item.hrefUrl" @click="goExternalLink(item.hrefUrl)" href="javascript:void(0);" class="school-link">招生网址</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/util/request"

export default {
  data() {
    return {
      schoolList: []
    }
  },
  mounted() {
    this.getSchoolList()
  },
  methods: {
    goExternalLink(url) {
      window.open(url);
    },
    getSchoolList() {
      request({
        method: 'get',
        url: '/articleInfo/school',
        params: {
          type: 7,
        }
      }).then(res => {
        if (res.code !== 0) return
        this.schoolList = res.data
      })
    }
  }
}
</script>

<style scoped lang="stylus">
.policyType5-banner {
  margin-top 6px
  vertical-align top
}
.policyType5-tips {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  margin: 10px 11px;
}
.policyType5-processImage {
  width: 983px;
  height: 137px;
  vertical-align: top;
  margin: 28px 0 40px 0;
}
.policyType5-titleImage {
  width: 659px;
  height: 19px;
  margin-bottom: 20px;
  vertical-align: top;

}

.policyType5-process {
  background: none;
  padding: 20px 0;
  background: #E4F3FF;
  border-radius: 8px;
  margin-top: 16px;
}


.policyType4Plan-title {
  text-align center
  font-weight: 600;
  font-size: 16px;
  color: #061E69;
  line-height: 16px;
  padding: 16px 0
}


.school {
  padding: 0 30px 0 38px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  .school-item {
    display: flex;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 16px 20px;
    width: 228px;
    height: 80px;
    box-sizing: border-box;
    flex-shrink: 0;
  }
  .school-image {
    width: 48px;
    height: 48px;
    vertical-align: top;
    margin-right: 16px;
  }
  .school-name {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    min-height: 28px;
    line-height: 14px;

    word-break: break-all;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .school-link {
    display: inline-flex;
    background: #50ABFF;
    border-radius: 2px;
    padding: 4px 6px;
    line-height: 12px;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
  }
}
</style>
